import { localeMapping } from "helpers/constants/localeMapping";
import { useParams } from "next/navigation";
import { FC, useEffect, useState } from "react";

interface ShopOnlineProps {
    itemCode: string;
}

const ShopOnline: FC<ShopOnlineProps> = ({ itemCode }) => {
    const { locale } = useParams();
    const localeKey = localeMapping[locale];

    //Declared this variable to set the body tag value
    const [currentStyle, setCurrentStyle] = useState('');
    let newBodyStyle = "";

    //Function to show scroll when popup not exists
    const showScroll = () => {
      document.body.style.overflow = '';
    };

    //Function to show scroll when popup exists
    const hideScroll = () => {
      document.body.style.overflow = 'hidden';
    };

    //This function call when user close the popup screen (Close Button)
    const updateBodyStyle = () => {
        const body = document.querySelector('body');
        if (body) {
            body.style.cssText = newBodyStyle;
        }
        showScroll();
    };

    //This function call when user click ShopOnline button
    const handleShopOnlineClick = () => {
      const body = document.body;
      if (body) {
        const inlineStyles = body.style.cssText;
        newBodyStyle = inlineStyles;
        setCurrentStyle(inlineStyles); 
        hideScroll();
      }
       
      //Here we are finding the widget's close button event.
      setTimeout(() => {
          const button = document.querySelector('button.csBtn-close');
          if (button) {
            const instanceId = button.getAttribute('data-dismiss'); // Corrected attribute name
            if (instanceId === 'csWidgetModal') { // Assuming this is the expected value
              const closeButton = document.getElementById('csModalButtonClose');
              if (closeButton) {
                closeButton.addEventListener('click', updateBodyStyle);
              }
            }
        }
      }, 2000);
    };


    useEffect(() => {
        // Function to add the script
        const addScript = () => {
            if (!document.getElementById('cswidgetloaderjs')) {
                const script = document.createElement('script');
                script.id = 'cswidgetloaderjs';
                script.src = 'https://cdn.channelsight.com/widget/scripts/cswidget.loader.js';
                script.async = true;
                document.body.appendChild(script);
            }
        };

        addScript(); // Initially add the script when the component mounts

        // Clean-up function to remove the event listener and script
        return () => {
            const closeButton = document.getElementById('csModalButtonClose');
            if (closeButton) {
                closeButton.removeEventListener('click', updateBodyStyle);
            }

            const cswidgetloaderjsscript = document.getElementById('cswidgetloaderjs');
            const cswidgetjsscript = document.getElementById('cswidgetjs');
            if (cswidgetloaderjsscript) {
              document.body.removeChild(cswidgetloaderjsscript);
            }
            if (cswidgetjsscript) {
              document.body.removeChild(cswidgetjsscript);
            }
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount

    // Set CSS values for ShopOnline button 
    return (
        <>
            {localeKey === 'en-NZ' && (
                <div
                data-asset-id="4180"
                className="bottom-0 mt-4 mb-4 flex items-center justify-between text-[#090909] font-medium"
              >
                <button
                  onClick={handleShopOnlineClick}
                  data-asset-id="4180"
                  data-product-sku={itemCode}
                  className="
                    w-90 cswidget bg-black text-white text-center rounded-md border-0
                    min-w-[90px] 
              
                    /* Mobile */
                    px-3 py-2 text-sm
              
                    /* Tablet */
                    md:px-4 md:py-3 md:text-11
              
                    /* Desktop / large screens */
                    lg:px-6 lg:py-4 lg:text-12
              
                    /* Extra large screens */
                    2xl:px-8 2xl:py-5 2xl:text-12
                  "
                >
                  Shop Online
                </button>
              </div>
            )}
        </>
    );
};

export default ShopOnline;
